import { render, staticRenderFns } from "./UserQualificationDelete.vue?vue&type=template&id=5ec6ccb6&"
import script from "./UserQualificationDelete.vue?vue&type=script&lang=js&"
export * from "./UserQualificationDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports